import React, { useEffect, useState } from 'react'
import { totalSuministrosSolicitadosDespachadosUsadosDevueltos } from '../../../services/FarmaciaRuta'

const ModalSuministrosUsadosDespachadosSolicitadosDevueltos = () => {
    const [dataSuministros, setdataSuministros]=useState([])
    const [sortColumn, setSortColumn] = useState(null);    
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    // Agregado: un nuevo estado para mantener los datos después de que se aplica el filtro.
    const [filteredData, setFilteredData] = useState([]);
    // Agregado: un nuevo estado para mantener el término de búsqueda actual.
    const [searchTerm, setSearchTerm] = useState("");
    useEffect(()=>{
        totalSuministrosSolicitadosDespachadosUsadosDevueltos().then((res)=>{
            console.log(res.data.data,'Suministros')
            setdataSuministros(res.data.data)
            setFilteredData(res.data.data)
        })
    },[])

    useEffect(() => {
        console.log(sortColumn,'sortColumn')
        if (sortColumn !== null) {
            setdataSuministros(oldData =>
            [...oldData].sort((a, b) => b[sortColumn] - a[sortColumn])
          );
        }
      }, [sortColumn]);

    
    // Agregado: un nuevo efecto que se ejecuta cuando el término de búsqueda o los datos cambian.
    // Filtra los datos en función del término de búsqueda y guarda los resultados en filteredData.
    useEffect(() => {
        if (searchTerm !== "") {
        setFilteredData(dataSuministros.filter((row) =>
            row.MSRESO.toString().includes(searchTerm) || row.MSNomG.toLowerCase().includes(searchTerm.toLowerCase())
        ));
        } else {
        setFilteredData(dataSuministros);
        }
        // Cuando el término de búsqueda cambia, también restablecemos la página actual a 1.
        setCurrentPage(1);
    }, [searchTerm, dataSuministros]);

        const lastIndex = currentPage * rowsPerPage;
        const firstIndex = lastIndex - rowsPerPage;
        const currentRows = filteredData.slice(firstIndex, lastIndex);

        // Ahora calculamos las páginas totales basadas en los datos filtrados, no todos los datos.
        const totalPages = Math.ceil(filteredData.length / rowsPerPage);
  return (
    
    
    <div className='p-6'>
        <div className="my-4">
            <input 
                type="text"
                placeholder="Buscar por código o suministro..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="
                p-2 
                w-full 
                border-2 
                border-blue-500
                rounded-lg 
                focus:outline-none 
                focus:ring-2 
                focus:ring-blue-600 
                focus:border-transparent
                shadow-md"
            />
        </div>
            <table className="table-auto w-full shadow-md rounded-lg overflow-hidden">
                <thead>
                    <tr className="bg-gray-300 text-gray-700">
                        <th className="px-4 py-2">Código</th>
                        <th className="px-4 py-2">Nombre del Suministro</th>
                        <th className="px-4 py-2 cursor-pointer" onClick={() => setSortColumn("TotalUsados")}>Total Usados</th>
                        <th className="px-4 py-2 cursor-pointer" onClick={() => setSortColumn("TotalDevuelto")}>Total Devueltos</th>
                        <th className="px-4 py-2 cursor-pointer" onClick={() => setSortColumn("TotalDespachado")}>Total Despachados</th>
                        <th className="px-4 py-2 cursor-pointer" onClick={() => setSortColumn("TotalSolicitado")}>Total Solicitados</th>
                    </tr>
                </thead>
                <tbody>
                {currentRows.map((row, index) => (
                    <tr className={index % 2 === 0 ? 'bg-gray-100' : ''} key={row.MSRESO}>
                    <td className="border px-4 py-2">{row.MSRESO}</td>
                    <td className="border px-4 py-2">{row.MSNomG}</td>
                    <td className="border px-4 py-2">{row.TotalUsados}</td>
                    <td className="border px-4 py-2">{row.TotalDevuelto}</td>
                    <td className="border px-4 py-2">{row.TotalDespachado}</td>
                    <td className="border px-4 py-2">{row.TotalSolicitado}</td>
                    </tr>
                ))}
                </tbody>
        </table>

        <div className="flex items-center justify-between mt-4">
                <div>
                <label htmlFor="pagination" className="mr-2">
                    Filas por página:
                </label>
                <select
                    id="pagination"
                    value={rowsPerPage}
                    onChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value));
                    setCurrentPage(1);
                    }}
                    className="rounded-md border-gray-300 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
                >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                </select>
                </div>

                <div>
                <button
                    onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
                    disabled={currentPage === 1}
                    className={`mx-1 py-1 px-3 rounded bg-indigo-500 text-white ${
                    currentPage === 1 && "opacity-50 cursor-not-allowed"
                    }`}
                >
                    Anterior
                </button>

                <span>{`${currentPage} de ${totalPages}`}</span>

                <button
                    onClick={() =>
                    setCurrentPage((page) => Math.min(page + 1, totalPages))
                    }
                    disabled={currentPage === totalPages}
                    className={`mx-1 py-1 px-3 rounded bg-indigo-500 text-white ${
                    currentPage === totalPages && "opacity-50 cursor-not-allowed"
                    }`}
                >
                    Siguiente
                </button>
                </div>
            </div>
    </div>
  )
}

export default ModalSuministrosUsadosDespachadosSolicitadosDevueltos